export const MD1 = {
    games: [
        {
            home_points: 0,
            guest_points: 0,
        },
    ],
    mode: 1,
    mode_string: '1.MD',
    player_home: ['Pedersen', 'Krishna'],
    player_guest: ['Juchim', 'Stuckenschneider'],
    home_team: 'BC Tempelhof',
    guest_team: 'TV Metjendorf',
    player_positioning: [
        [0, 1],
        [2, 3],
    ],
    server: -1,
    receiver: -1,
    serving_team: -1,
    state: -1,
    standing: [0, 0],
};
